/* __next_internal_client_entry_do_not_use__ TertiaryButton auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import styled from "styled-components";
import { TextAction, onClickTextAction } from "./common";
var StyledButton = styled.button.withConfig({
    componentId: "sc-afd1de59-0"
})([
    "",
    ";display:inline-block;width:fit-content;"
], function(props) {
    return props.disabled ? "cursor: default" : "";
});
/**
 * @deprecated use Button from faire/web/slate/Button with prop variant="tertiary" or EmbeddedLink from faire/web/ui/EmbeddedLink if within a sentence
 * @supersededBy "@faire/web--source/slate/Button/Button#Button"
 * @trackcomponent
 */ export var TertiaryButton = function(_param) {
    var postEventButtonId = _param.postEventButtonId, onClick = _param.onClick, icon = _param.icon, animate = _param.animate, color = _param.color, hoverColor = _param.hoverColor, children = _param.children, disabled = _param.disabled, typographyStyles = _param.typographyStyles, props = _object_without_properties(_param, [
        "postEventButtonId",
        "onClick",
        "icon",
        "animate",
        "color",
        "hoverColor",
        "children",
        "disabled",
        "typographyStyles"
    ]);
    return /*#__PURE__*/ _jsx(StyledButton, _object_spread_props(_object_spread({
        onClick: onClickTextAction(onClick, postEventButtonId),
        disabled: disabled
    }, props), {
        children: /*#__PURE__*/ _jsx(TextAction, {
            animate: animate,
            color: color,
            hoverColor: hoverColor,
            icon: icon,
            disabled: disabled,
            typographyStyles: typographyStyles,
            children: children
        })
    }));
};
